<!-- Category Badge - Colored pill for agent categories -->
<span 
  class="category-badge" 
  [ngClass]="variantClass"
  [attr.aria-label]="'Category: ' + (category | translate)">
  {{ category | translate }}
</span>
